(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name accounts.controller:AccountsCtrl
   *
   * @description
   *
   */
  angular
      .module('core')
      .controller('MainController', MainController);

  function MainController($rootScope, $q, UserSettingsService, ConfigEndpointService,
                          $log, ViberService, EndpointsService, HelperService) {

    var vm = this;
    vm.isAuthenticated = false;
    $rootScope.APP_GLOBAL_SETTINGS = {};

    //$q.all([TimelineService.syncTimeline()])
    //    .then(function (responses) {
    //      var loginInfoTime = responses[0];
    //      $rootScope.APP_GLOBAL_SETTINGS.loginInfo = loginInfoTime;
    //      loadGlobalSettings();
    //    })
    //    .catch(function (error, status) {
    //      $log.debug("Error: ", error);
    //      $log.debug("Status: ", status);
    //      if(status !== 401 && status !== 403) {
    //        loadGlobalSettings();
    //      }
    //      //vm.isAuthenticated = false;
    //      //SessionService.authorize();
    //
    //    });

    function init() {
      EndpointsService.getLinks()
        .then(function (response) {
          loadGlobalSettings();
        })
        .catch(function (error) {
          HelperService.showMessage(error, 'error');
        })
    }


    /*
    POSTO POZIV NA API IDE SAMO RADI loginInfo a zatim se na Dashboardu ponovo poziva - dodao sam da se ovaj podatak pokupi u dashboard controlleru
    TimelineService.syncTimeline()
      .then(function (response){
        $rootScope.APP_GLOBAL_SETTINGS.loginInfo = response[0];
      })
      .catch(function (error){
        $log.debug("Sync Error: ", error);
      });
    */

    function loadGlobalSettings() {
      $rootScope.APP_GLOBAL_SETTINGS.counters = {};

      $q.all([ConfigEndpointService.getDefaultData(), UserSettingsService.getPage()])
          .then(function (responses) {
            // 1. response
            var defaultData = responses[0];
            $rootScope.APP_GLOBAL_SETTINGS.defaultData = defaultData;
            // 2. response
            var userSettings = responses[1].result[0];
            $rootScope.APP_GLOBAL_SETTINGS.userSettings = userSettings;
          $log.debug("$rootScope.APP_GLOBAL_SETTINGS.userSettings.authenticationUserId", $rootScope.APP_GLOBAL_SETTINGS.userSettings.authenticationUserId);
            //check if user activated Viber only for BiH environment
            if(defaultData.APILocation != 'sl'){
              ViberService.checkActivation()
                .then(function (response){
                  $rootScope.APP_GLOBAL_SETTINGS.isViberActivated = response.result;
                })
                .catch(function (error) {
                  HelperService.showMessage(error, 'error');
                });
            }

            vm.isAuthenticated = true;
          })
          .catch(function (error) {
            //vm.isAuthenticated = false;
            $log.debug("loadGlobalSettings error: ", error);
          });
    }


    init();
  }
}());
